import React from 'react';
import clsx from 'clsx';

import classes from './textLimit.module.css';

type Props = {
  limit: number;
  reveal: number;
  text: string;
};

const TextLimit = ({ limit, reveal, text }: Props) => {
  const currentTextCount = text.length;
  const limitText = `${currentTextCount} / ${limit}`;
  const isRevealed = currentTextCount + reveal > limit;

  return (
    <React.Fragment>
      {isRevealed && (
        <div
          className={clsx(
            classes.textLimit,
            currentTextCount >= limit && classes.red,
          )}
        >
          {limitText}
        </div>
      )}
    </React.Fragment>
  );
};

export default TextLimit;
